export * from './lib/text-area.module';
